
import axios from "utils/axiosConfig";
import { urlService } from "infra/envs";
import {  useRef, useState, useCallback } from "react";

const prepareQuery = (query) => {
    return query.trim().replaceAll(/ /g, "+");
};

const DEBOUNCE_TIMEOUT = 500;

function debounce(fn, delay) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), delay);
    };
}

export default function useSearchLocations( relocationSearch = false ) {
    const [locations, setLocations] = useState([]);
    const [isSearchLocationsLoading, setIsSearchLocationsLoading] = useState(false);
    const [error, setError] = useState(null);

    const controllerRef = useRef(null);
    const fetchUrl = relocationSearch ? urlService.RELOCATION_SEARCH_LOCATION_PATH : urlService.SEARCH_LOCATION_PATH;
    const fetchLocations = useCallback(async (query) => {
        if (!query || query.length < 3) {
            setLocations([]);
            return;
        }

        setIsSearchLocationsLoading(true);
        setError(null);

        if (controllerRef.current) {
            controllerRef.current.abort();
        }

        const controller = new AbortController();
        controllerRef.current = controller;

        try {
            const response = await axios.get(
                `${fetchUrl}?query=${prepareQuery(query)}`,
                { signal: controller.signal }
            );
            setLocations(response.data);
        } catch (err) {
            if (axios.isCancel(err)) {
                console.log('Request canceled', err.message);
            } else {
                console.error('Search error:', err);
                setError(err);
            }
        } finally {
            setIsSearchLocationsLoading(false);
        }
    }, [fetchUrl]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchLocations = useCallback(
        debounce(fetchLocations, DEBOUNCE_TIMEOUT),
        [fetchLocations, DEBOUNCE_TIMEOUT, debounce, locations]
    );

    return {
        setLocations,
        locations,
        isSearchLocationsLoading,
        error,
        fetchLocations: debouncedFetchLocations,
    };
}
